import React, {  Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import ProfileTabs from './ProfileTabs';

import _ from 'lodash';

import {
	updateUserAccounts,
	saveUsersOfAccount
} from '../../../redux/actions';

/*Dialogs*/
import ConfirmDeleteUserDialog from '../../dialogs/confirmDeleteUserDialog';
import ConfirmDeleteUserDialogSuccess from '../../dialogs/confirmDeleteUserDialogSuccess';
import ConfirmUpdateManageUsersResposibilities from '../../dialogs/confirmUpdateManageUsersResposibilities';
import ConfirmApproveRequestDialog from '../../dialogs/confirmApproveRequestDialog';
import ConfirmRejectUserRequestDialog from '../../dialogs/confirmRejectUserRequestDialog';
import NoSelectionsMadeDialog from '../../dialogs/noSelectionsMadeDialog';
import SelectionsNotConfirmed from '../../dialogs/selectionsNotConfirmed';

class UserRequests extends Component {

    constructor(props) {
        super(props);
        this.state = {
			// viewRequestSelectedUserId: '',
			// step1SelectedData: [],

			step2SelectedData: [],

			doesAllowLeaveThisPage: true,
			showSelectionsNotConfirmed:false,
			nextLocation: '',

			legacyPayload: null,

			step: 0,
			showNoSelectionMadeDialog: false,
			showConfirmApproveRequestDialog: false,
			showConfirmRejectUserRequestDialog: false,
			approvedORRejectedUserFirstName: '',
			approvedORRejectedUserLastName: '',
			approvedORRejectedUserAccountNumber: '',
			approvedORRejectedUserUserId: '',
			approvedORRejectedUserEmailAddress: '',
			approvedORRejectedUserRole: null,
			showConfirmation: false,
			usersOfAccount: null,
			newUserPendingRequests: null,
			existingUserPendingRequests: null,
			userPendingRequests: null,
			deletingUserId: '',
			showConfirmDeleteUserDialog:false,
            showConfirmDeleteUserDialogSuccess:false,
			showConfirmUpdateManageUsersResposibilities:false,
		}
		this.handleResponsibilityChange = this.handleResponsibilityChange.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.handleDeleteClick = this.handleDeleteClick.bind(this);
		this.updateAccount = this.updateAccount.bind(this);
		this.updateDetails = this.updateDetails.bind(this);
		this.resetResponsibilities = this.resetResponsibilities.bind(this);
		this.updateNewAndExistingUsersAccount = this.updateNewAndExistingUsersAccount.bind(this);
    }

	updateDetails() {
		event.preventDefault();

		const self = this,
			{ usersOfAccount, approvedORRejectedUserEmailAddress, approvedORRejectedUserFirstName, approvedORRejectedUserLastName } = self.state,
			{ selectedAccount } = self.props.state.user;

		self.handleDialog('ConfirmUpdateManageUsersResposibilities', false);

		self.setState({
			errorMessage: "",
			showConfirmation: false
		});

		let accountRequests = [];

		usersOfAccount.responseObject.map(item => {
			const tempItm = JSON.parse(JSON.stringify(item));
			if(!_.isEqual(tempItm, _.find(self.props.state.user.usersOfAccount.responseObject, ['userId', item.userId]))) {
				const approvedAccounts = _.filter(item.accounts, {approvalStatus: 'Approved', accountNumber: selectedAccount.ACCOUNTNUMBER});
				if(approvedAccounts.length > 0 && !_.isEqual(item.accounts)) {
					accountRequests = accountRequests.concat(approvedAccounts);
				}
			}
			return null;
		});

		const queryStringParams = `requestType=updateAccounts&userApproved=y&emailAddress=${approvedORRejectedUserEmailAddress}&userName=${approvedORRejectedUserFirstName} ${approvedORRejectedUserLastName}`;
		//After hiding make service call of registration
		self.props.updateUserAccounts(accountRequests, queryStringParams, response => {
			if(response.status) {
				self.setState({
					showConfirmation: true
				});
				self.props.saveUsersOfAccount(JSON.parse(JSON.stringify(self.state.usersOfAccount)));
				self.goToStep(0);
				window.scrollTo(0, 0);
				self.updateNewAndExistingUsersAccount(usersOfAccount);
			} else {
				browserHistory.push("/error");
			}
		});
    }

	resetResponsibilities() {
		const { usersOfAccount } = this.props.state.user;
		this.setState({
			usersOfAccount: JSON.parse(JSON.stringify(usersOfAccount))
		});
	}

	handleDeleteClick(userId, event) {
		event.preventDefault();
		this.setState({
			deletingUserId: userId
		})
		this.handleDialog('ConfirmDeleteUserDialog', true);
	}

	handleResponsibilityChange(userId, responsibility, event) {
		const self = this;
		const { usersOfAccount } = self.state;
		const { selectedAccount } = self.props.state.user;
		const checked = event.target.checked;
		usersOfAccount.responseObject.forEach((item, index) => {
			if(item.userId === userId) {
				const indexOfAccount = _.findIndex(item.accounts, { accountNumber: selectedAccount.ACCOUNTNUMBER });
				if(responsibility === "Admin Access") {
					item.accounts[indexOfAccount].admin = checked?"Y":"N";
				} else {
					let responsibilities = item.accounts[indexOfAccount].responsibilities;
					responsibilities = responsibilities?responsibilities:[];
					if(checked) {
						responsibilities.push(responsibility);
					} else {
						if (responsibility === 'Returns/Credits') {
							// For older records which contains Returns so for safer side removing that as well
							// For all new updates it will pass Returns/Credits
							responsibilities.indexOf('Returns') !== -1 && responsibilities.splice(responsibilities.indexOf('Returns'), 1);
						}
						responsibilities.indexOf(responsibility) !== -1 && responsibilities.splice(responsibilities.indexOf(responsibility), 1);
					}
					if((responsibility === 'Price Discounts' || responsibility === "Create New Order" || responsibility === "Edit Orders") && checked) {
						responsibilities.push("Price");
						responsibilities.push("Price Discounts");
					} else if(responsibility === 'Price' && !checked) {
						responsibilities.indexOf('Create New Order') !== -1 && responsibilities.splice(responsibilities.indexOf("Create New Order"), 1);
						responsibilities.indexOf('Price Discounts') !== -1 && responsibilities.splice(responsibilities.indexOf("Price Discounts"), 1);
						responsibilities.indexOf('Edit Orders') !== -1 && responsibilities.splice(responsibilities.indexOf("Edit Orders"), 1);
					} else if(responsibility === 'Price Discounts' && !checked) {
						responsibilities.indexOf('Create New Order') !== -1 && responsibilities.splice(responsibilities.indexOf("Create New Order"), 1);
						responsibilities.indexOf('Edit Orders') !== -1 && responsibilities.splice(responsibilities.indexOf("Edit Orders"), 1);
					}
					responsibilities = _.uniq(responsibilities);
					item.accounts[indexOfAccount] = {
						...item.accounts[indexOfAccount],
						responsibilities: responsibilities.length > 0 ? responsibilities : null
					}
				}
			}
		});

		this.setState({
			usersOfAccount,
			errorMessage: ''
		});
	}

	componentWillMount() {
		this.unregisterLeaveHook = this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
		const { userDetails } = this.props.state.user;
		if(!this.props.isEmployeeHasAccessTo('User Requests') && !(userDetails && userDetails.typeOfUser === "customer" && userDetails.isAdmin)) {
			browserHistory.push("/profile/myProfile");
		}

		const usersOfAccount = JSON.parse(JSON.stringify(this.props.state.user.usersOfAccount));
		this.updateNewAndExistingUsersAccount(usersOfAccount);
	}

	updateNewAndExistingUsersAccount(usersOfAccount) {
		const { selectedAccount } = this.props.state.user;
		let newUserPendingRequests = [],
			existingUserPendingRequests = [];
		if(usersOfAccount && usersOfAccount.responseObject) {
			usersOfAccount.responseObject.map((item, index) => {
				const pendingRequestsAccounts = _.filter(item.accounts, {approvalStatus: 'Pending', accountNumber: selectedAccount.ACCOUNTNUMBER});
				if(pendingRequestsAccounts.length > 0) {
					pendingRequestsAccounts.forEach(account => {
						switch(account.userRole) {
							case 'buyer':
								account.responsibilities = ['Create New Order', 'Edit Orders', 'Invoices and Payments', 'Price', 'Price Discounts', 'Returns/Credits', 'View Orders', 'View Reports'];
								break;
							case 'owner':
								account.admin = 'Y';
								account.responsibilities = ['Create New Order', 'Edit Orders', 'Invoices and Payments', 'Price', 'Price Discounts', 'Returns/Credits', 'View Orders', 'View Reports'];
								break;
							case 'sales':
								account.responsibilities = ['Price', 'Price Discounts', 'View Orders'];
								break;
						}
					});

					if(!item.accounts.find(itm => itm.approvalStatus === "Approved")) {
						newUserPendingRequests.push({...item, accounts: pendingRequestsAccounts});
					} else {
						existingUserPendingRequests.push({...item, accounts: pendingRequestsAccounts});
					}
				}
				return null;
			})
		}
		this.setState({
			usersOfAccount,
			newUserPendingRequests,
			existingUserPendingRequests
		});
	}

	routerWillLeave(nextLocation) {
		if(this.state.step !== 0 && nextLocation.pathname.indexOf('/login') === -1) {
			this.setState({
				showSelectionsNotConfirmed: !this.state.doesAllowLeaveThisPage,
				nextLocation: nextLocation.pathname
			})
			return this.state.doesAllowLeaveThisPage;
		} else {
			return true
		}
	}

	goToStep(step, event) {
		event && event.preventDefault();
		this.setState({
			step: step
		});
	}

	handleLeaveThisPage(event) {
		event.preventDefault();
		this.setState({
			doesAllowLeaveThisPage: true,
			showSelectionsNotConfirmed: false
		})
		browserHistory.push(this.state.nextLocation);
	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleApproveOrRejectClick(userId, accountNumber, firstName, lastName, status, emailAddress, typeOfUser, accounts, event) {
		event.preventDefault();
		var self = this;
		const account = accounts.find(account => account.accountNumber === accountNumber) || {};

		self.setState({
			approvedORRejectedUserAccountNumber: accountNumber,
			approvedORRejectedUserUserId: userId,
			approvedORRejectedUserFirstName: firstName,
			approvedORRejectedUserLastName: lastName,
			approvedORRejectedUserEmailAddress: emailAddress,
			approvedORRejectedUserRole: account.userRole,
			showConfirmApproveRequestDialog: status === "Approved"?true:false,
			showConfirmRejectUserRequestDialog: status === "Rejected"?true:false,
			showConfirmation: false,
			typeOfUser: typeOfUser
		});
	}

	handleApproveOrRejectServiceCall(status, event) {
		event && event.preventDefault();
		const self = this,
			{ usersOfAccount } = self.state;
		if(status === "Approved" || status === "Rejected") {
			//reset messages and overlays and Close the dialog
			self.setState({
				showConfirmation: false,
				showConfirmApproveRequestDialog: false,
				showConfirmRejectUserRequestDialog: false
			});
			// Make service call to approve or reject account
			const tempUsersOfAccount = JSON.parse(JSON.stringify(usersOfAccount));
			let accountRequests = [];
			tempUsersOfAccount.responseObject.forEach(item => {
				if(item.userId === self.state.approvedORRejectedUserUserId) {
					item.accounts.forEach(itm => {
						if(itm.accountNumber === self.state.approvedORRejectedUserAccountNumber) {
							itm.approvalStatus = status;
							accountRequests.push(itm);
						}
					});
				}
			})

			if(status === 'Approved') {
				self.updateNewAndExistingUsersAccount(tempUsersOfAccount);
				self.goToStep(2);
			} else {
				self.props.updateUserAccounts(accountRequests, 'requestType=updateAccounts', response => {
					if(response.status) {
						self.setState({
							showConfirmation: true
						});
						self.updateNewAndExistingUsersAccount(tempUsersOfAccount);
						self.props.saveUsersOfAccount(JSON.parse(JSON.stringify(tempUsersOfAccount)));
					} else {
						browserHistory.push("/error");
					}
				});
			}
		}
	}

	updateAccount(event){
		event.preventDefault();

		const self = this,
			{ usersOfAccount } = self.props.state.user,
			stateUsersOfAccount = self.state.usersOfAccount;

		self.setState({
			errorMessage: "",
			updateMessage: false
		})
		if(_.isEqual(stateUsersOfAccount, usersOfAccount)) {
			self.setState({
				errorMessage: "Please select at least one item."
			})
		} else {
			self.handleDialog('ConfirmUpdateManageUsersResposibilities', true);
		}
    }

	deleteUser(event) {
		event && event.preventDefault();
		const self = this,
			{ usersOfAccount } = self.state,
			{ selectedAccount } = self.props.state.user;

		self.setState({
			errorMessage: "",
			updateMessage: false
		});

		self.handleDialog("ConfirmDeleteUserDialog", false);

		let accountIndex = 0,
			payload = [];
		usersOfAccount.responseObject.forEach(item => {
			if(item.userId === self.state.deletingUserId) {
				accountIndex = _.findIndex(item.accounts, {accountNumber: selectedAccount.ACCOUNTNUMBER});
				item.accounts[accountIndex] = {
					...item.accounts[accountIndex],
					approvalStatus: 'Deleted'
				}
				payload.push(item.accounts[accountIndex]);
			}
		});

		self.updateNewAndExistingUsersAccount(usersOfAccount);

		self.props.updateUserAccounts(payload, 'requestType=updateAccounts', response => {
			if(response.status) {
				self.setState({
					showConfirmDeleteUserDialogSuccess: true
				});
				self.goToStep(0);
			} else {
				browserHistory.push("/error");
			}
		});
    }

    render() {
		const { usersOfAccount, approvedORRejectedUserUserId, newUserPendingRequests, existingUserPendingRequests } = this.state;
		const { selectedAccount } = this.props.state.user;

        return (
			<div>
				<ProfileTabs isEmployeeHasAccessTo={this.props.isEmployeeHasAccessTo} selectedTab='userRequests' />
				<p className={"importantText bold "+(this.state.showConfirmation?"show":"hide")}>Updates have been saved.</p>
				{this.state.step === 0?
					<div>
				        <div className="push">
				          	<p>The following users are requesting access to accounts on CustomerNet.</p>
				        </div>
			        	<div className="push">
			          		<h2>New User Requests</h2>
			          		<hr />
			          		<table className="userRequestsTable newUserRequestsTable">
			            		<tbody>
									{newUserPendingRequests && newUserPendingRequests.map((item, index) => {
										return <tr key={index}>
				                			<td>
				                  				<b className="fieldName">User Name:</b> {item.firstName} {item.lastName}
				                			</td>
				                			<td>
				                  				<b className="fieldName">Email:</b> {item.emailAddress}
				                			</td>
				                			<td>
				                  				<a className="blueButton approveLink" data-user-name="Firstname Lastname" onClick={this.handleApproveOrRejectClick.bind(this, item.userId, selectedAccount.ACCOUNTNUMBER, item.firstName, item.lastName, "Approved", item.emailAddress, "newUsers", item.accounts)} href="">Approve</a>
				                			</td>
				                			<td>
				                  				<a className="blueButton rejectLink" data-user-name="Firstname Lastname" onClick={this.handleApproveOrRejectClick.bind(this, item.userId, selectedAccount.ACCOUNTNUMBER, item.firstName, item.lastName, "Rejected", item.emailAddress, "newUsers", item.accounts)} href="">Reject</a>
				                			</td>
				              			</tr>
									})}
									{newUserPendingRequests === null?<tr><td className="txt-ctr"><div style={{width:40, height: 40}} className={"loader account-number-loader"}>&#160;</div></td></tr>:null}
									{newUserPendingRequests && newUserPendingRequests.length === 0?<tr><td className="txt-ctr"><p>No requests available.</p></td></tr>:null}
			            		</tbody>
			          		</table>
		        		</div>
			        	<div className="push">
			          		<h2>Existing User Requests</h2>
			          		<hr />
			          		<table className="userRequestsTable newUserRequestsTable">
			            		<tbody>
									{existingUserPendingRequests && existingUserPendingRequests.map((item, index) => {
										return <tr key={index}>
				                			<td>
				                  				<b className="fieldName">User Name:</b> {item.firstName} {item.lastName}
				                			</td>
											<td>
				                  				<b className="fieldName">Email:</b> {item.emailAddress}
				                			</td>
											<td>
				                  				<a className="blueButton approveLink" data-user-name="Firstname Lastname" onClick={this.handleApproveOrRejectClick.bind(this, item.userId, selectedAccount.ACCOUNTNUMBER, item.firstName, item.lastName, "Approved", item.emailAddress, "existingUsers", item.accounts)} href="">Approve</a>
				                			</td>
				                			<td>
				                  				<a className="blueButton rejectLink" data-user-name="Firstname Lastname" onClick={this.handleApproveOrRejectClick.bind(this, item.userId, selectedAccount.ACCOUNTNUMBER, item.firstName, item.lastName, "Rejected", item.emailAddress, "existingUsers", item.accounts)} href="">Reject</a>
				                			</td>
				              			</tr>
									})}
									{existingUserPendingRequests === null?<tr><td className="txt-ctr"><div style={{width:40, height: 40}} className={"loader account-number-loader"}>&#160;</div></td></tr>:null}
									{existingUserPendingRequests && existingUserPendingRequests.length === 0?<tr><td className="txt-ctr"><p>No requests available.</p></td></tr>:null}
			            		</tbody>
			          		</table>
			        	</div>
					</div>
				:null}
				{this.state.step === 2 &&
					<div>
						<p className="push"><a className="bold" href="" onClick={this.updateDetails.bind(this)}>&lt; Return to User Requests</a></p>
						<div className="push">
					        <h1>Step 2 of 2: <span className="unbold">Assign Responsibilities</span></h1>
				          	<h2 className="unbold" style={{display: 'flex', flexWrap: 'wrap', columnGap: '1.5rem', rowGap: '.3rem'}}>
								<span><b>User Name:</b>&nbsp; {this.state.approvedORRejectedUserFirstName} {this.state.approvedORRejectedUserLastName}</span>
								{this.state.approvedORRejectedUserRole && <span><b>Role:</b>&nbsp;{this.state.approvedORRejectedUserRole}</span>}
								<span className="text-break"><b>Email:</b>&nbsp;{this.state.approvedORRejectedUserEmailAddress}</span>
							</h2>
					        <p>Please assign responsibilities for each of the accounts listed below.</p>
							{this.state.updateMessage?<p className="importantText bold">Updates have been saved.</p>:null}
							<p className="red bold">{this.state.errorMessage}</p>
					        <form onSubmit={this.updateAccount.bind(this)} className="assignResponsibilitiesForm" name="assignResponsibilitiesForm" id="assignResponsibilitiesForm">
					          	<div className="dataTableContainer">
					            	<table className="dataTable assignResponsibilitiesTable">
					              		<thead>
											<tr>
												<th>Select user to see all accounts tied to that user</th>
												<th>Price</th>
												<th>Price Discounts</th>
												<th>View Orders</th>
												<th>Create New Order</th>
												<th>Edit Orders</th>
												<th>Returns/<br/>Credits</th>
												<th>Invoices and Payments</th>
												<th>View Reports</th>
												<th className="yellowHighlight">Manage Users <i>(Account Administrator)</i></th>
												<th>Delete User</th>
											</tr>
					              		</thead>
					              		<tbody>
											{usersOfAccount && usersOfAccount.responseObject && usersOfAccount.responseObject.map((item, index) => {
												if(item.userId !== approvedORRejectedUserUserId) {
													return null;
												}
												const { userDetails, selectedAccount } = this.props.state.user;
												const accountIndex = _.findIndex(item.accounts, {accountNumber: selectedAccount.ACCOUNTNUMBER});
												if(accountIndex === -1) {
													return null
												}
												const userRole = item.accounts[accountIndex].userRole;
												let responsibilities = item.accounts[accountIndex].responsibilities;
												responsibilities = responsibilities?responsibilities:[];
												return <tr key={index}>
													<td>{item.firstName +' '+ item.lastName}</td>
													<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Price')} checked={responsibilities.indexOf('Price') !== -1 ? true : false} disabled={userRole} /></td>
													<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Price Discounts')} checked={responsibilities.indexOf('Price Discounts') !== -1 ? true : false} disabled={userRole} /></td>
													<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'View Orders')} checked={responsibilities.indexOf('View Orders') !== -1 ? true : false} disabled={userRole} /></td>
													<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Create New Order')} checked={responsibilities.indexOf('Create New Order') !== -1 ? true : false} disabled={userRole} /></td>
													<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Edit Orders')} checked={responsibilities.indexOf('Edit Orders') !== -1 ? true : false} disabled={userRole} /></td>
													<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Returns/Credits')} checked={(responsibilities.indexOf('Returns') !== -1 || responsibilities.indexOf('Returns/Credits') !== -1) ? true : false} disabled={userRole} /></td>
													<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Invoices and Payments')} checked={responsibilities.indexOf('Invoices and Payments') !== -1 ? true : false} disabled={userRole} /></td>
													<td><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'View Reports')} checked={responsibilities.indexOf('View Reports') !== -1 ? true : false} disabled={userRole} /></td>
													<td className="yellowHighlight"><input type="checkbox" onChange={this.handleResponsibilityChange.bind(this, item.userId, 'Admin Access')} defaultChecked={item.accounts[accountIndex].admin === "Y"} disabled={userRole || (item.userId !== this.props.state.user.userDetails.sso ? false : true)} /></td>
													<td>{item.userId !== userDetails.sso ? <a className="deleteUserLink" onClick={this.handleDeleteClick.bind(this, item.userId)} href="#">Delete</a> : null}</td>
												</tr>
											})}
					              		</tbody>
				            		</table>
					          	</div>
					          	<p className="textRight">
					            	<input className="blueButton" type="submit" value="Confirm Selections" />
					          	</p>
					        </form>
				      	</div>
					</div>
				}
				{this.state.showConfirmApproveRequestDialog?<ConfirmApproveRequestDialog
					firstName={this.state.approvedORRejectedUserFirstName}
					lastName={this.state.approvedORRejectedUserLastName}
					showDialog={true}
					handleDialog={this.handleDialog}
					handleApproveOrRejectServiceCall={this.handleApproveOrRejectServiceCall.bind(this)} />:null}
				{this.state.showConfirmRejectUserRequestDialog?<ConfirmRejectUserRequestDialog
					firstName={this.state.approvedORRejectedUserFirstName}
					lastName={this.state.approvedORRejectedUserLastName}
					showDialog={true}
					handleDialog={this.handleDialog}
					handleApproveOrRejectServiceCall={this.handleApproveOrRejectServiceCall.bind(this)} />:null}
				{this.state.showNoSelectionMadeDialog?<NoSelectionsMadeDialog showDialog={true} handleDialog={this.handleDialog} />:null}
				{this.state.showSelectionsNotConfirmed?<SelectionsNotConfirmed showDialog={true} handleDialog={this.handleDialog} handleLeaveThisPage={this.handleLeaveThisPage.bind(this)}/>:null}
				{this.state.showConfirmDeleteUserDialog?<ConfirmDeleteUserDialog deleteUser={this.deleteUser.bind(this)} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showConfirmDeleteUserDialogSuccess?<ConfirmDeleteUserDialogSuccess handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showConfirmUpdateManageUsersResposibilities?<ConfirmUpdateManageUsersResposibilities resetResponsibilities={this.resetResponsibilities.bind(this)} updateDetails={this.updateDetails.bind(this)} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
			</div>
        );
    }
}
const mapStateToProps = (state) => {
    return {state};
};

const mapDispatchToProps = (dispatch) => ({
	updateUserAccounts: (payload, hybridQueryParams, callback) => dispatch(updateUserAccounts(payload, hybridQueryParams, callback)),
	saveUsersOfAccount: (data) => dispatch(saveUsersOfAccount(data)),
});

UserRequests = connect(mapStateToProps, mapDispatchToProps)(UserRequests);
export default UserRequests;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Profile/UserRequests.js